import basicdata from '@kaili/api/api.basicdata'
export default [
  {
    type: 'input',
    placeholder: '设备SN码',
    filed: 'assetNumber',
    default: ''
  },
  {
    type: 'cascader',
    placeholder: '设备类型型号',
    filed: 'typeNumber',
    default: [],
    query: basicdata.device_model_cascade
  }
]
